export const tr = {
    'adjustments-rate': 'Teklifler, bunlara uygulanan düzenlemeler dikkate alınmadan gösterilir'
};
